import {usePageModelsStore} from "@/store/modules/pageModels";
import {PageEnum} from "@/enums/pageEnum";
import {initDefValues, initDefValuesByFun} from "@/main-page/utils/initValues";
import {getAllFieldKeys} from "@/main-page/utils/funDealUtils";
import {CtlComEnum} from "@/main-page/enums/ctlComEnum";
import {GoingNewUtils} from 'xmgoing-utils';
import {useFormElDesHook} from "@/main-page/ctls/hooks/useFormElDesHook";
import {_initVuexPropValFun, isVuexTotalDefaultSet} from "@/main-page/ctls/hooks/useVuexState";

interface IPropCtl {
  propId,
  propLabel,
  propValue
}

export const addPropToStore = function ({
                                          _dataType,
                                          propName,
                                          ctlType,
                                          propLabel,
                                          propValue,
                                          propType,
                                          pageModelsStore,
                                          modelObj
                                        }) {
  const itemObj = pageModelsStore.stateRemarks.filter((dbItem) => {
    return unref(dbItem).value === propName;
  })[0];
  //如果组件中不存在 则放到vuex里面缓存
  if (modelObj[propName] == null || itemObj == null) {
    let dataType = 'string';
    if (propValue != null) {
      dataType = typeof propValue;
    }
    pageModelsStore.setStateValue({
      ctlType,
      label: propLabel,
      value: propName,
      defValue: propValue,
      dataType: _dataType || dataType,
      modelObj,
      defValueType: 'systemDef',
      propType,
    });
    modelObj[propName] = propValue;
  } else {
    if (unref(itemObj)["label"] !== propLabel) {
      unref(itemObj)["label"] = propLabel;
    }
  }
}
/**
 * 根据keys 从store里面删除相应元素
 * @param keys
 */
const delModelsState = function (pageModelsStore, keys) {
  keys.forEach((propId) => {
    pageModelsStore.deleteState(propId);
  })

}

export interface IPropItem {
  propName: string,
  record: any,
  propLabel: string,
  propType: string,
  propValue: any
}

export interface IUseComElState {
  componentKey: string;
  pItemType:any;
  editorRowFlag?: boolean;
  initDefValFlag?: string;
  _dataType?: string;
  initModel?: boolean,
  modFlag?: boolean;
  record?: any,
  model: any,
  props: any,
  pModelObj: any,
  defValue?: any,
  vuexState?: any,
}

/**
 * 判断是否有值（truthy；0 视为无值）
 * @param pModelObj
 * @param modelKey
 */
const isHasValue = function (pModelObj, modelKey) {
  if (unref(pModelObj) != null && unref(pModelObj)[modelKey]) {
    return true;
  }
  return false;
}

/** 字段本值：null/''/undefined 为空；数字 0 视为有效本值 */
const hasFieldOwnValue = function (pModelObj, modelKey) {
  if (unref(pModelObj) == null) {
    return false;
  }
  const val = unref(pModelObj)[modelKey];
  return val !== null && val !== undefined && val !== '';
}

export function useComElState({
                                pItemType='xmForm',
                                editorRowFlag,
                                initDefValFlag,
                                _dataType,
                                vuexState,
                                componentKey = '',
                                initModel = true,
                                model = {},
                                props,
                                pModelObj,
                                defValue,
                                modFlag = false,
                                record
                              }: IUseComElState) {
  //定义 从全局模型中获取对应字段的值或者对象
  const pageModelsStore: any = usePageModelsStore();
  const modelObj = computed(() => {
    if (unref(pModelObj)) {
      return unref(pModelObj);
    }
    return pageModelsStore.getModelObj(model, pModelObj)
  })
  onMounted(() => {
    if (initModel && unref(model) && unref(model).key && ((unref(pModelObj) && unref(pModelObj) === unref(pageModelsStore.state)) || unref(pModelObj) == null)) {
      addPropToStore({
        _dataType,
        propName: unref(model).key,
        propLabel: unref(props).label,
        propType: PageEnum.SYSTEM_PROP_STATE,
        propValue: defValue || unref(model).defValue,
        ctlType: componentKey,
        pageModelsStore,
        modelObj
      })
    }
  });

  onBeforeUnmount(() => {
  })

  let changeTimer: any = null;
  let totalContinuousWatchSetup = false;
  /** 编辑有本值：保护本值，合计相对（同步求值得到的）基线变化后再写入并转为持续同步 */
  let editTotalProtectMode = false;
  let editTotalBaseline: any = undefined;
  let editIdWatchSetup = false;

  /**
   * 监听值对编号
   * @param allFieldKeys
   * @param propDef
   */
  const watchFieldChang = function (allFieldKeys, propDef) {
    if (allFieldKeys && Array.isArray(allFieldKeys)) {
      allFieldKeys.forEach((fieldKey) => {
        //如果存在动态子表类似的 层级机构
        if (fieldKey.indexOf(".") >= 0) {
          const fileKeyAry = fieldKey.split(".")[0];
          watch(() => unref(pModelObj)[fileKeyAry], () => {
            if (changeTimer) {
              clearTimeout(changeTimer);
            }
            changeTimer = setTimeout(() => {
              initDefValuesByFun({propDef, props, modelObj, componentKey, model, record}, true);
            }, 400)
          }, {deep: true})
        } else {
          watch(() => unref(pModelObj)[fieldKey], () => {
            if (changeTimer) {
              clearTimeout(changeTimer);
            }
            changeTimer = setTimeout(() => {
              initDefValuesByFun({propDef, props, modelObj, componentKey, model, record}, true);
            }, 300)
          })
        }
      })
    }
  }
  /**
   * 根据函数模式 和 快捷模式进行数据初始化
   * @param propDef
   */
  const initValueByDefConfig = function (propDef, valueType = '') {
    if (typeof (propDef) && Array.isArray(propDef)) {
      initDefValuesByFun({propDef, props, modelObj: pModelObj, componentKey, model, record}, true);
      const allFieldKeys = getAllFieldKeys(propDef);
      watchFieldChang(allFieldKeys, propDef);
    } else {
      initDefValues({
        pItemType,
        state: pageModelsStore.state,
        valueType,
        propDef,
        props,
        defFormat: props.format || "YYYY-MM-DD",
        modelObj: pModelObj,
        model,
        componentKey
      });
    }
  }

  const totalsEqual = function (a, b) {
    if (a == null && b == null) {
      return true;
    }
    if (a == null || b == null || a === '' || b === '') {
      return a === b;
    }
    const na = Number(a);
    const nb = Number(b);
    if (!isNaN(na) && !isNaN(nb)) {
      return na === nb;
    }
    return a === b;
  };

  const writeDefaultSetToField = function (newVal) {
    if (newVal == null || newVal === '') {
      return;
    }
    unref(pModelObj)[unref(model).key] = newVal;
  };

  /**
   * 直接对 defaultSetVuex 表达式求值，拿到"此刻"真实的合计结果。
   * 不依赖 useVuexState 里另一个 watcher 是否已经算完——避免用它可能过期/未就绪的
   * 缓存值当基线，这是之前"230 闪成 200"的真正原因（两个 watcher 的执行时序竞态）。
   */
  const computeCurrentTotal = function () {
    const vuexStr = unref(props)?.defaultSetVuex;
    if (!vuexStr) {
      return undefined;
    }
    const tempResult: any = {};
    _initVuexPropValFun(tempResult, {vuexStr, propName: 'v', state: pageModelsStore.state});
    return tempResult.v;
  };

  /** 进入「编辑本值保护」：立即同步求值当前合计作为基线，之后仅在合计偏离基线时才写入 */
  const enableEditTotalProtect = function () {
    if (editTotalProtectMode) {
      return;
    }
    editTotalProtectMode = true;
    editTotalBaseline = computeCurrentTotal();
  };

  const handleTotalDefaultSetChange = function (newVal) {
    // 非保护：新建 / 编辑空本值 / 已发生过一次合计变化后 — 持续写入
    if (!editTotalProtectMode) {
      writeDefaultSetToField(newVal);
      return;
    }
    // 保护中：合计相对基线变化 → 写入并退出保护（之后持续同步）
    if (!totalsEqual(newVal, editTotalBaseline)) {
      editTotalProtectMode = false;
      writeDefaultSetToField(newVal);
    }
  };

  const syncDefaultSetWatch = function (vuex) {
    if (totalContinuousWatchSetup || !unref(vuex)) {
      return;
    }
    totalContinuousWatchSetup = true;
    watch(() => unref(vuex)[CtlComEnum.DEFAULT_SET], (newVal) => {
      nextTick(() => {
        handleTotalDefaultSetChange(newVal);
      })
    })
  };

  /** 控件早于详情：id+本值到位后同步切入保护，并立即求值基线（sync，抢在合计 nextTick 写入前） */
  const watchEditIdForTotalProtect = function () {
    if (editIdWatchSetup) {
      return;
    }
    editIdWatchSetup = true;
    watch(
      () => ({
        id: unref(pModelObj)?.id,
        own: unref(pModelObj)?.[unref(model).key],
      }),
      () => {
        if (editTotalProtectMode || !isVuexTotalDefaultSet(unref(props)?.defaultSetVuex)) {
          return;
        }
        if (unref(pModelObj)?.id == null || unref(pModelObj)?.id === '') {
          return;
        }
        if (!hasFieldOwnValue(pModelObj, unref(model).key)) {
          return;
        }
        enableEditTotalProtect();
      },
      {flush: 'sync'}
    );
  };

  /**
   * 初始化默认值
   */
  const initDefValue = function (setValueFlag = false) {
    //如果是编辑列进来的组件 则不需要当前的进行初始化
    if (unref(editorRowFlag) === true) {
      return;
    }
    const vuex = vuexState;
    if (unref(model) == null) {
      return;
    }
    const modelKey = unref(model).key;
    const isVuexTotalDefault = isVuexTotalDefaultSet(unref(props)?.defaultSetVuex);
    const isEditMode = unref(modelObj)?.['id'] != null;
    const hasOwn = hasFieldOwnValue(pModelObj, modelKey);
    const forceByEditor = GoingNewUtils.parseBoolean(unref(props).editorChange) || setValueFlag || unref(modFlag);

    // 编辑 + 合计 + 已有本值：显示本值；合计相对（同步求值的）基线变化后再更新
    if (isVuexTotalDefault && isEditMode && hasOwn && !forceByEditor) {
      enableEditTotalProtect();
      syncDefaultSetWatch(vuex);
      return;
    }

    //如果存在值 常规情况下应该直接返回 不需要进行执行
    if (isHasValue(pModelObj, modelKey)) {
      // 新建合计类需持续同步；编辑有本值的合计已在上方 return
      if (!(forceByEditor || isVuexTotalDefault)) {
        return;
      }
    }
    const propDef = unref(props).defaultValue;
    if (unref(vuex)) {
      initValueByDefConfig(propDef, unref(vuex)[CtlComEnum.DEFAULT_SET]);
    }
    //如果存在 全局状态值（合计为 0 时也需赋值，不能用 truthy 判断）
    const defaultSetVal = unref(vuex)?.[CtlComEnum.DEFAULT_SET];
    // 新建可赋；合计类在编辑空本值时可赋；编辑有本值已 return
    const canAssignDefault = !isEditMode || isVuexTotalDefault;
    if (unref(vuex) && defaultSetVal != null && defaultSetVal !== '' && canAssignDefault) {
      if (defaultSetVal === CtlComEnum.USER_DEF_VAL || defaultSetVal === CtlComEnum.GONG_SI_EDITOR || defaultSetVal === CtlComEnum.COMMON_DEF_VAL) {
        return '';
      }
      if (defaultSetVal === "session缓存" || defaultSetVal === "全局状态变量") {
        return;
      }
      // 无 id 时可能是编辑详情未回填：先写合计，同时监听 id 以便切入本值保护
      writeDefaultSetToField(defaultSetVal);
      syncDefaultSetWatch(vuex);
      if (isVuexTotalDefault) {
        watchEditIdForTotalProtect();
      }
    } else if (unref(vuex) && isVuexTotalDefault) {
      syncDefaultSetWatch(vuex);
      watchEditIdForTotalProtect();
    } else {
      //如果为空 但可能从空变成不空的情况啊
      if (unref(vuex) && (unref(vuex)[CtlComEnum.DEFAULT_SET] === '' || unref(vuex)[CtlComEnum.DEFAULT_SET] == null)) {
        watch(() => unref(vuex)[CtlComEnum.DEFAULT_SET], (newVal) => {
          nextTick(() => {
            handleTotalDefaultSetChange(newVal);
          })
        })
      }
    }


    /**
     * 进行数据初始化操作
     */
    watch([() => unref(props).initElValFlag, () => unref(props).defaultValue], () => {
      nextTick(() => {
        const propDef = unref(props).defaultValue;
        if (propDef) {
          if (unref(props).disabled === true) {
            return;
          }
          initValueByDefConfig(propDef);
        }
      })
    })
  }


  const addExtendProp: Array<IPropCtl> = [];
  //添加控件属性
  const addStateCtlsProp = ({propId, propLabel, propValue}) => {
    addPropToStore({
      propName: propId,
      propLabel: propLabel,
      propType: PageEnum.PAGE_CTLS,
      propValue: propValue,
      pageModelsStore,
      ctlType: componentKey,
      _dataType,
      modelObj: pageModelsStore.state
    });
    addExtendProp.push({propId, propLabel, propValue});
  }

  onBeforeUnmount(() => {
    addExtendProp.forEach(({propId}) => {
      delModelsState(pageModelsStore, [propId]);
    })
  })

  /**
   * 编辑状态下hook
   */
  useFormElDesHook({vuexState, model, initDefValFlag, initDefValue, props, pModelObj, componentKey, pItemType});

  return {
    addStateCtlsProp,
    initDefValue,
    modelObj
  }
}
